import styled from "styled-components";

export const Separator = styled.div`
  height: 1px;
  width: 100%;
  opacity: 0.3;
  border: solid 1px ${props => props.theme.border.divider};
`;
